var map = {
	"./en": [
		63969,
		969
	],
	"./en.json": [
		63969,
		969
	],
	"./sv": [
		3315,
		315
	],
	"./sv.json": [
		3315,
		315
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76643;
module.exports = webpackAsyncContext;